import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { Link, withRouter } from 'react-router'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'

import classNames from './Queues.css'
import { fetchQueues, saveQueue, deleteQueue } from '../redux/queues'
import { fetchPlaylists, savePlaylist } from '../redux/playlists'
import { fetchAlbums } from '../redux/albums'
import { searchImages } from '../redux/search'
import LoadingSpinner from '../components/LoadingSpinner'
import ErrorMessage from '../components/ErrorMessage'
import EmptyNotice from '../components/EmptyNotice'
import QueueEditor from '../components/playlist/QueueEditor'
import { clearPlaylistEditorCache } from './PlaylistEditor'
import { createImageGetter } from '../utils/images'
import { picassoFetch } from '../utils/fetch'

class Queues extends Component {
  componentDidMount () {
    const { queues, fetchQueues, playlists, fetchPlaylists, albums, fetchAlbums } = this.props
    if (!queues) fetchQueues()
    if (!playlists) fetchPlaylists()
    if (!albums) fetchAlbums()

    clearPlaylistEditorCache()
    this.props.router.setRouteLeaveHook(this.props.route, this.routerWillLeave)
  }
  routerWillLeave = () => {
    if (this.refs.editor && this.refs.editor.isUnsaved() && !this.refs.editor.preventSaveAlert) {
      return 'Your changes have not been saved. Are you sure you want to leave?'
    }
  }
  renderQueue = queue => {
    const { entities } = this.props
    const playlists = JSON.parse(queue.json_data).playlists
    return (
      <Link key={queue.id} to={`/queues/${queue.id}`} className={classNames.queue}>
        <div className={classNames.name}>
          {queue.name}
        </div>
        <div className={classNames.info}>
          <div className={classNames.heading}>Playlists:</div>
          <div className={classNames.playlists}>
            {playlists.map(id => {
              const playlist = entities.playlists[id]
              if (!playlist) return null
              return (
                <span className={classNames.playlist}>
                  {playlist.name}
                </span>
              )
            })}
          </div>
        </div>
      </Link>
    )
  }
  render () {
    const { queues, playlists, error, fetchQueues, fetchPlaylists } = this.props

    if (error.queues) {
      return (
        <ErrorMessage
          message='There was an error fetching queue'
          onRetry={fetchQueues}
        />
      )
    }

    if (error.playlists) {
      return (
        <ErrorMessage
          message='There was an error fetching playlists'
          onRetry={fetchPlaylists}
        />
      )
    }

    if (!queues || !playlists) {
      return <LoadingSpinner />
    }

    const { params, entities } = this.props

    if (params.id) {
      return (
        <QueueEditor
          ref='editor'
          queue={params.id === 'create' ? null : entities.queues[params.id]}
          {...this.props}
        />
      )
    }

    if (queues.length === 0) {
      return (
        <div className={classNames.page}>
          <EmptyNotice
            heading='Create a queue'
            text='A queue is a list of playlists to be presented in a channel.'
          />
          <Link to='/queues/create' className={classNames.button} style={{ margin: '20px auto' }}>
            Create a queue
          </Link>
        </div>
      )
    }

    return (
      <div className={classNames.page}>
        <Link to='/queues/create' className={classNames.button}>
          Create new queue
        </Link>
        {queues.map(this.renderQueue)}
      </div>
    )
  }
}

const mapStateToProps = ({ queues, playlists, albums, entities, search, auth }) => {
  return {
    queues: queues.data && queues.data.map(id => entities.queues[id]),
    playlists: playlists.playlists && playlists.playlists.map(id => entities.playlists[id]),
    albums: albums.all.data && albums.all.data.map(id => entities.albums[id]),
    submitting: queues.submitting,
    error: {
      queues: queues.error,
      playlists: playlists.error
    },
    entities,
    search,
    getImageSource: createImageGetter(auth),
    checkForConflicts: queue => picassoFetch(auth, 'validate_queue', { queue_id: queue.id }),
    sendToPlayNow: id => picassoFetch(auth, 'add_to_play_now', { queue_id: id }),
    userDefaultLocation: auth.user.location_address || auth.user.location
  }
}

const mapDispatchToProps = dispatch => ({
  ...bindActionCreators({
    fetchQueues,
    saveQueue,
    deleteQueue,
    fetchPlaylists,
    savePlaylist,
    fetchAlbums,
    searchImages
  }, dispatch),
  editPlaylist: id => dispatch(push(`/playlists/${id}`)),
  presentChannel: id => dispatch(push(`/present/${id}`))
})

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Queues))



// WEBPACK FOOTER //
// ./src/pages/Queues.js